import Cookies from 'js-cookie';

var getTrackingData = function getTrackingData() {
  var data = {};
  var ga = Cookies.get('_ga');

  if (ga) {
    data.ga = ga;
  }

  var sjID = Cookies.get('sjID');

  if (sjID) {
    data.sjID = sjID;
  }

  return data;
};

export { getTrackingData };
//# sourceMappingURL=utils.esm.js.map
